const API_LINK = "https://warm-escarpment-17665.herokuapp.com/api/v1/";
//const API_LINK = "http://localhost:5000/api/v1/";
const API_LINK_ITEMS_POSTFIX = API_LINK + "items/";
const API_LINK_SESSIONS_POSTFIX = API_LINK + "sessions/";
const API_LINK_REGISTRATIONS_POSTFIX = API_LINK + "registrations/";
const API_LINK_USERSHOW_POSTFIX = API_LINK + "specialshow/";

export {
  API_LINK,
  API_LINK_ITEMS_POSTFIX,
  API_LINK_SESSIONS_POSTFIX,
  API_LINK_REGISTRATIONS_POSTFIX,
  API_LINK_USERSHOW_POSTFIX,
};
